"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var matches_1 = require("./matches");
exports.parents = function (e, selector) {
    var ancestors = [];
    var parent = e.parentNode;
    while (parent instanceof Element) {
        ancestors.push(parent);
        parent = parent.parentNode;
    }
    if (selector !== undefined) {
        return ancestors.filter(function (ancestor) {
            return matches_1.matches(ancestor, selector);
        });
    }
    else {
        return ancestors;
    }
};
